export { DMS_MODULE } from '../constants';
export const NAME = 'DokladyOjetychVozu';
export const CRUMB_LABEL_KEY = 'edtDokladOV';
